import { createLucideIcon } from "lucide-react";

export const ArrowReloadVertical = createLucideIcon(
    "arrow-reload-vertical",
    [
        [
            "path",
            {
                d: "M12.3333 13.6664L12.3333 6.33309C12.3333 3.85757 10.5433 1.99976 8 1.99976",
                key: "17aqew",
            },
        ],
        [
            "path",
            {
                d: "M13.9993 12C13.9993 12 12.7719 13.6667 12.3327 13.6667C11.8935 13.6667 10.666 12 10.666 12",
                key: "1mhwe5",
            },
        ],
        [
            "path",
            {
                d: "M3.66602 2.33301L3.66602 9.66634C3.66602 12.1419 5.45604 13.9997 7.99935 13.9997",
                key: "1siwlm",
            },
        ],
        [
            "path",
            {
                d: "M5.33333 3.66665C5.33333 3.66665 4.10585 2 3.66665 2C3.22746 2 2 3.66667 2 3.66667",
                key: "173qw9",
            },
        ],
    ],
);
